import React from 'react';
import { useTranslation } from 'react-i18next';
import UrpassInfo from './UrpassInfo';
import { IonItem } from '@ionic/react';
import UrpassSelect from './UrpassSelect';
import { UrPassAgency } from '../../services/types/urpassapitypes';

type UrpassAddProps = {
  agencies: UrPassAgency[] | undefined;
  agency: UrPassAgency | undefined;
  changeAgency: () => void;
};
export default function UrpassAdd({
  agencies,
  agency,
  changeAgency,
}: UrpassAddProps) {
  const [t] = useTranslation('global');

  return (
    <>
      <h1 className="h1 pb-2 ion-text-center">{t('urpassadd.addpasses')}</h1>
      <UrpassInfo></UrpassInfo>

      <h1 className="h1 pt-2">{t('urpassadd.chooseagency')}</h1>
      {agencies && agencies.length && (
        <IonItem
          lines="none"
          detail={true}
          onClick={() => changeAgency()}
          className="ion-no-padding ion-pt-1 pseudo-select pseudo-select-active"
        >
          {agency && (
            <UrpassSelect
              title={agency.name}
              subTitle={agency.location}
              icon={agency.id}
            />
          )}
        </IonItem>
      )}
    </>
  );
}
